"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var AspectRatioBox_1 = require("../AspectRatioBox");
var Box_1 = require("../Box");
var Clickable_1 = require("../Clickable");
var MultiSelect_1 = require("../MultiSelect");
var Container = (0, styled_components_1.default)(Clickable_1.Clickable)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  &:focus {\n    outline: 0;\n  }\n"])));
var hyphenate = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n"], ["\n  word-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n"])));
var Name = (0, styled_components_1.default)(Box_1.Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-decoration-break: clone;\n  ", "\n"], ["\n  box-decoration-break: clone;\n  ", "\n"])), hyphenate);
var Meta = (0, styled_components_1.default)(Box_1.Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), hyphenate);
var File = function (_a) {
    var name = _a.name, meta = _a.meta, _b = _a.selected, defaultSelected = _b === void 0 ? false : _b, _c = _a.payload, payload = _c === void 0 ? {} : _c, children = _a.children, onMouseDown = _a.onMouseDown, rest = __rest(_a, ["name", "meta", "selected", "payload", "children", "onMouseDown"]);
    var _d = __read((0, react_1.useState)("Default"), 2), mode = _d[0], setMode = _d[1];
    var _e = (0, MultiSelect_1.useMultiSelect)({ defaultSelected: defaultSelected, payload: payload }), isWrapped = _e.isWrapped, multiSelectOnMouseDown = _e.onMouseDown, ref = _e.ref, selected = _e.selected;
    var handleMouseDown = function (event) {
        onMouseDown && onMouseDown(event);
        multiSelectOnMouseDown(event);
    };
    var handleFocus = function () {
        setMode("Focused");
    };
    var handleBlur = function () {
        setMode("Default");
    };
    var highlighted = isWrapped ? selected : mode === "Focused";
    return (react_1.default.createElement(Container, __assign({ ref: ref, onMouseDown: handleMouseDown, display: "inline-block", onFocus: handleFocus, onBlur: handleBlur }, rest),
        react_1.default.createElement(Box_1.Box, { m: 1 },
            react_1.default.createElement(AspectRatioBox_1.AspectRatioBox, { aspectWidth: 1, aspectHeight: 1, maxWidth: "100%" },
                react_1.default.createElement(Box_1.Box, { p: 2, bg: highlighted ? "hint" : "transparent", borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "left", overflow: "hidden", width: "100%", height: "100%" }, children)),
            react_1.default.createElement(Box_1.Box, { maxWidth: "80%", mt: 1, mx: "auto", lineHeight: 0, textAlign: "center" },
                name && (react_1.default.createElement(Name, { as: "span", fontSize: 0, borderRadius: 4, px: 2, py: 1, bg: highlighted ? "hint" : "transparent" }, name)),
                meta && (react_1.default.createElement(Meta, { mt: 2, fontSize: 0, color: "secondary" }, meta))))));
};
exports.File = File;
exports.File.defaultProps = {
    width: "100%",
    selected: false,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=File.js.map